// Apart from `dice-bar-states`, which the roller saves wholesale. The board reads it for each roll, never the toggle.
const THROW_KEY = "dice-throw";

export function throwEnabled() {
	try {
		return localStorage.getItem(THROW_KEY) !== "off";
	} catch {
		return true;
	}
}

export function setThrow(on: boolean) {
	try {
		localStorage.setItem(THROW_KEY, on ? "on" : "off");
	} catch {
		// A private window or blocked storage only loses the switch.
	}
}

export function reducedMotion() {
	return globalThis.matchMedia?.("(prefers-reduced-motion: reduce)").matches ?? false;
}

// The dice bar's settings (`hide`, `mute`, `volume`, `formula`), shared by the roller and the live sheet, so a
// preference follows the person between pages.
const STATES_KEY = "dice-bar-states";

export type DiceStates = { hide?: boolean; mute?: boolean; volume?: number; formula?: boolean };

// What the bar shows now, kept apart from storage so a browser that blocks it cannot lose a secret roll's toggle.
let held: DiceStates | null = null;

export function holdDiceStates(states: DiceStates) {
	held = states;
}

export const heldDiceStates = (): DiceStates => held ?? diceStates();

// The dice sound's step: 0 muted, then low, medium and high. Medium until the person picks another.
export function diceVolume() {
	const { mute, volume } = heldDiceStates();
	if (mute) return 0;
	return volume === 1 || volume === 3 ? volume : 2;
}

export function diceStates(): DiceStates {
	try {
		return JSON.parse(localStorage.getItem(STATES_KEY)) ?? {};
	} catch {
		return {};
	}
}

export function saveDiceStates(patch: DiceStates) {
	try {
		localStorage.setItem(STATES_KEY, JSON.stringify({ ...diceStates(), ...patch }));
	} catch {
		// A private window or blocked storage only loses the preference.
	}
}
